import { highlightCode } from 'app/highlightCode';

const LANGUAGE_BY_EXTENSION: Record<string, string> = {
  js: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  css: 'css',
  json: 'json',
  py: 'python',
};

export const languageForPath = (path: string): string | null => {
  const extension = /\.([a-z0-9]+)$/i.exec(path)?.[1]?.toLowerCase();
  return (extension && LANGUAGE_BY_EXTENSION[extension]) || null;
};

export const highlightSource = (path: string, content: string): string =>
  highlightCode(content, languageForPath(path));

export const countLines = (content: string) =>
  Math.max(1, content.replace(/\n$/, '').split('\n').length);
